import { render, staticRenderFns } from "./Negociacao.vue?vue&type=template&id=1010c01e&scoped=true"
import script from "./Negociacao.vue?vue&type=script&lang=js"
export * from "./Negociacao.vue?vue&type=script&lang=js"
import style0 from "./Negociacao.vue?vue&type=style&index=0&id=1010c01e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1010c01e",
  null
  
)

export default component.exports